import { graphql } from '@/generated/gql';

export const INTAKE_SUPPLIER_SELECTION_NEXT_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeSupplierSelectionNext($data: SvbrgIntakeRequestSupplierNext!) {
    sevenbridges {
      chatSession {
        supplierSelection {
          next(data: $data) {
            id
            internalId
            isQuoted
            source
            reason
            contact {
              firstName
              lastName
              email
              internalId
              language
              mobile
              phone
            }
            location {
              address
              city
              countryCode
              internalId
              postalCode
            }
          }
        }
      }
    }
  }
`);
